import type { UseFormRegisterReturn } from 'react-hook-form';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { apiUserIpAllowlistError } from '../../lib/apiUserIpAllowlist';

interface Props {
    id: string;
    value: string;
    registration: UseFormRegisterReturn;
    /** Error del submit o del backend; el error al vuelo tiene prioridad. */
    error?: string;
}

/** Campo de IPs permitidas de un usuario de API, con la validación al vuelo del rbac. */
export function IpAllowlistField({ id, value, registration, error }: Props) {
    const liveError = value.trim() ? apiUserIpAllowlistError(value) : null;
    const message = liveError ?? error;
    const hintId = `${id}-hint`;
    const errorId = `${id}-error`;
    return (
        <div className="space-y-2">
            <Label htmlFor={id}>IPs permitidas</Label>
            <Textarea
                id={id}
                rows={4}
                className="font-mono"
                placeholder={'189.128.0.0/16\n201.20.30.40'}
                aria-invalid={message ? true : undefined}
                aria-describedby={message ? `${errorId} ${hintId}` : hintId}
                {...registration}
            />
            {message && (
                <p id={errorId} className="text-sm text-destructive">
                    {message}
                </p>
            )}
            <p id={hintId} className="text-xs text-muted-foreground">
                Una por línea: IP suelta o rango (CIDR), máximo 20. El login solo funciona desde
                estas IPs públicas.
            </p>
        </div>
    );
}
